<template>
  <Wrapper>
    <Topo v-if="isMobile" />
    <LoginMain>
      <v-card
        color="transparent"
        outlined="outlined"
        :max-width="isMobile ? '400px' : '585px'"
        :class="isMobile ? 'mx-auto' : ''"
      >
        <LoginTitulo>
          <template v-slot:titulo>
            {{ tituloDaPagina }}
          </template>
        </LoginTitulo>
        <v-form class="mt-5 mt-md-8">
          <v-col class="my-0 pa-0">
            <v-text-field
              v-model="user"
              background-color="#FFF"
              filled
              label="E-mail"
              required
              type="email"
              data-cy="input_email"
              :error-messages="errorMessagesEmail"
              @focus="hideMessage"
            />

            <SnackBar
              :mensage="validationMessage"
              :snackbar="invalidCredentials"
              @changeSnackBar="snackbar => invalidCredentials = snackbar.visible"
            />

            <v-text-field
              v-model="password"
              :append-icon="show1 ? 'visibility' : 'visibility_off'"
              :type="show1 ? 'text' : 'password'"
              background-color="#FFF"
              label="Senha"
              filled
              required
              data-cy="input_password"
              :error-messages="errorMessagesPasswords"
              @click:append="show1 = !show1"
              @focus="hideMessage"
            />

            <VueRecaptcha
              load-recaptcha-script
              :sitekey="recaptchaKey"
              @verify="setRecaptchaToken"
            >
              <v-btn
                data-cy="button_entrar"
                color="primary"
                dark
                :absolute="isDesktop"
                :block="isMobile"
                :class="isDesktop ? 'btn-entrar-desktop' : ''"
                :disabled="disabled"
                :loading="loading"
                @click="login"
              >
                Entrar
              </v-btn>
            </VueRecaptcha>
          </v-col>
        </v-form>

        <v-btn
          color="primary"
          class="primary--text mt-3 mt-md-0"
          data-cy="button_esqueciSenha"
          outlined
          :absolute="isDesktop"
          :block="isMobile"
          :class="isDesktop ? 'btn-senha-desktop' : ''"
          @click="goToForgotPassword"
        >
          Não sei a minha senha
        </v-btn>

        <Rastreio />
      </v-card>
    </LoginMain>
    <Rodape
      :exibe-central="true"
    />
  </Wrapper>
</template>

<script>

import VueRecaptcha from 'vue-recaptcha';
import { required, minLength, email } from 'vuelidate/lib/validators';
import ApiAuth from '@/api/auth';
import cookies from 'js-cookie';
import Wrapper from '../components/Wrapper.vue';
import LoginMain from '../components/Login/LoginMain.vue';
import LoginTitulo from '../components/Login/LoginTitulo.vue';
import SnackBar from '../components/SnackBar.vue';
import Topo from '../components/Topo.vue';
import Rodape from '../components/Rodape.vue';
import Rastreio from '../components/Login/Rastreio.vue';

export default {
  name: 'Login',

  components: {
    VueRecaptcha,
    Wrapper,
    LoginTitulo,
    LoginMain,
    SnackBar,
    Topo,
    Rodape,
    Rastreio,
  },

  beforeRouteEnter(to, from, next) {
    const { params: { reload = false } } = to;

    if (reload) {
      next((vm) => {
        vm.reloadPage();
      });
    }

    next();
  },

  data() {
    return {
      outlined: false,
      show1: false,
      user: this.$route.query.login || '',
      password: '',
      url: '',
      flat: false,
      invalidCredentials: false,
      loading: false,
      disabled: false,
      recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
      recaptchaToken: '',
      validationMessage: '',
      error: [],
      invalidUserMessage: ['Por favor, preencha o e-mail corretamente.'],
      invalidPassWordMessage: ['Por favor, preencha a senha corretamente.'],
      invalidCaptchaMessage: ['Por favor, preencha o captcha corretamente.'],
      tituloDaPagina: 'Olá! Acesse todas as suas compras em um só lugar.',
      invalidCredentialsMessage: 'E-mail ou Senha incorreto(s).',
    };
  },

  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    validationRules() {
      const rules = {
        user: {
          required,
          email: (value, vm) => value.indexOf('@-') === -1 && email(value, vm),
          minLength: minLength(4),
        },
        password: {
          required,
          minLength: minLength(8),
        },
        recaptchaToken: { required },
      };

      return rules;
    },

    errorMessagesEmail() {
      if (this.$v.user.$dirty && this.$v.user.$invalid) {
        return this.invalidUserMessage;
      }

      return [];
    },

    errorMessagesPasswords() {
      if (this.$v.password.$dirty && this.$v.password.$invalid) {
        return this.invalidPassWordMessage;
      }

      return [];
    },
  },

  validations() {
    return this.validationRules;
  },

  methods: {

    setRecaptchaToken(token) {
      this.recaptchaToken = token;
      this.login();
    },

    async login() {
      this.$v.$touch();
      this.$vuetify.goTo('body');

      if (this.$v.$invalid) {
        return;
      }

      const formData = new FormData();
      formData.set('login', this.user);
      formData.set('password', this.password);
      formData.set('recaptcha', this.recaptchaToken);
      this.loading = true;

      try {
        const dataLogin = await ApiAuth.login(formData);

        this.$store.dispatch('setUserEmail', this.user);
        this.$store.dispatch('setToken', dataLogin.data.accessToken);
        this.$store.dispatch('setUser', dataLogin.data.userName);
        cookies.remove('tokenMatrix');
        const urlDepoisLogin = this.$store.state.urlAntesLogin !== '' ? this.$store.state.urlAntesLogin : '/minhas-compras';
        this.$router.push(urlDepoisLogin);
      } catch (error) {
        this.invalidCredentials = true;
        this.validationMessage = this.invalidCredentialsMessage;

        this.loading = false;
        this.password = '';
        this.user = '';
      }
    },

    hideMessage() {
      this.invalidCredentials = false;
    },

    goToForgotPassword() {
      this.$router.push('/nao-sei-minha-senha');
    },

    reloadPage() {
      this.$router.go(this.$router.currentRoute);
    },

  },
};
</script>

<style scoped lang="scss">
.btn-entrar-desktop {
  right: 0;
  width: calc(50% - 15px);
}
.btn-senha-desktop {
  width: calc(50% - 15px);
}
</style>

<style lang="scss">
.grecaptcha-badge {
  bottom: 60px !important;
}
</style>
